export default __webpack_public_path__ + "static/media/tar-21.20ae9a42.svg";